// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Journey-Service (J-S::B2C) API
 * ## SBB Journey-Planner  (de:Fahrplanpublikation Personenverkehr SBB)  This is a stateless RESTful web-service for **timetable based public transportation routing** as provided by SBB Journey-Planner applications such as [sbb.ch](https://www.sbb.ch/) or [SBB Mobile App](https://apps.apple.com/ch/app/sbb-mobile/id294855237). The service-contract is restricted to **SBB internal consumers** or **accredited partners** and supports various and enhanced use cases.  ### Before \'Sign up\'  For new consumers: 1. This **service needs official approval** before granting any access, therefore send an e-mail (see \'Contact -> E-Mail\') first with the subject: **Request: Sign Up Journey-Service** 2. Wait for the appropriate response e-mail and fill-in the attached **Questionnaire** and follow further steps given in the response.    ### Approved and \'Signed up\' consumers See **Contact** box * **Homepage** for general infos about the service  * **Developer resources** for specific usage and concepts of Journey-Service  See **Blog** on PRODuction for Release-Notes.  Remark: * Please read the **Service-Contract** description in Swagger-Doc carefully. * For further questions, send an e-Mail.  
 *
 * The version of the OpenAPI document: 3.20.32.2
 * Contact: journey-service@sbb.ch
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FacilityForInfoPortalResponse,
  InheritanceResponse,
  PlaceResponse,
  Problem,
  StopPlaceDetailed,
  StopPlaceDetailedResponse,
  VehicleModeEnum,
} from '../models/index';
import {
    FacilityForInfoPortalResponseFromJSON,
    FacilityForInfoPortalResponseToJSON,
    InheritanceResponseFromJSON,
    InheritanceResponseToJSON,
    PlaceResponseFromJSON,
    PlaceResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    StopPlaceDetailedFromJSON,
    StopPlaceDetailedToJSON,
    StopPlaceDetailedResponseFromJSON,
    StopPlaceDetailedResponseToJSON,
    VehicleModeEnumFromJSON,
    VehicleModeEnumToJSON,
} from '../models/index';

export interface GetDummyInheritanceRequest {
    requestID?: string;
}

export interface GetFacilityForInfoPortalRequest {
    id: string;
    requestID?: string;
    acceptLanguage?: GetFacilityForInfoPortalAcceptLanguageEnum;
}

export interface GetFacilityForInfoPortal1Request {
    id: string;
    requestID?: string;
    acceptLanguage?: GetFacilityForInfoPortal1AcceptLanguageEnum;
}

export interface GetPlacesByCoordinatesRequest {
    longitude: number;
    latitude: number;
    requestID?: string;
    acceptLanguage?: GetPlacesByCoordinatesAcceptLanguageEnum;
    radius?: number;
    limit?: number;
    type?: Array<GetPlacesByCoordinatesTypeEnum>;
    includeVehicleModes?: boolean;
}

export interface GetPlacesByCoordinatesGeojsonRequest {
    center: string;
    requestID?: string;
    acceptLanguage?: GetPlacesByCoordinatesGeojsonAcceptLanguageEnum;
    radius?: number;
    limit?: number;
    type?: Array<GetPlacesByCoordinatesGeojsonTypeEnum>;
    includeVehicleModes?: boolean;
}

export interface GetPlacesByNameRequest {
    nameMatch: string;
    requestID?: string;
    acceptLanguage?: GetPlacesByNameAcceptLanguageEnum;
    type?: Array<GetPlacesByNameTypeEnum>;
    limit?: number;
    center?: string;
    radius?: number;
    includeVehicleModes?: boolean;
    includeTouristicVia?: boolean;
}

export interface GetStopPlaceByIdRequest {
    id: string;
    requestID?: string;
    acceptLanguage?: GetStopPlaceByIdAcceptLanguageEnum;
    date?: Date;
}

export interface GetStopPlacesRequest {
    requestID?: string;
    acceptLanguage?: GetStopPlacesAcceptLanguageEnum;
    countryCode?: string;
    sortOrder?: GetStopPlacesSortOrderEnum;
    validDate?: Date;
    validFrom?: Date;
    validTo?: Date;
    vehicleModes?: Array<VehicleModeEnum>;
    nameMatch?: string;
    tariffZone?: string;
    nearby?: string;
    limit?: number;
}

/**
 * 
 */
export class PlacesV3Api extends runtime.BaseAPI {

    /**
     * ApiClient **inherited sub-classes** reference.
     * PATCH for OpenApi-Plugin-Generator (temporary).
     * @deprecated
     */
    async getDummyInheritanceRaw(requestParameters: GetDummyInheritanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InheritanceResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/INCUBATOR/openapi/dummy-patch`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InheritanceResponseFromJSON(jsonValue));
    }

    /**
     * ApiClient **inherited sub-classes** reference.
     * PATCH for OpenApi-Plugin-Generator (temporary).
     * @deprecated
     */
    async getDummyInheritance(requestParameters: GetDummyInheritanceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InheritanceResponse> {
        const response = await this.getDummyInheritanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the facility as for InfoPortal. Temporary solution before it goes to a PlaceService. 
     * Get the facility as for InfoPortal.
     */
    async getFacilityForInfoPortalRaw(requestParameters: GetFacilityForInfoPortalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FacilityForInfoPortalResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFacilityForInfoPortal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/stop-places/{id}/facility-info-portal`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FacilityForInfoPortalResponseFromJSON(jsonValue));
    }

    /**
     * Get the facility as for InfoPortal. Temporary solution before it goes to a PlaceService. 
     * Get the facility as for InfoPortal.
     */
    async getFacilityForInfoPortal(requestParameters: GetFacilityForInfoPortalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FacilityForInfoPortalResponse> {
        const response = await this.getFacilityForInfoPortalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the facility as for InfoPortal. Temporary solution before it goes to a PlaceService. 
     * Get the facility as for InfoPortal.
     */
    async getFacilityForInfoPortal1Raw(requestParameters: GetFacilityForInfoPortal1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FacilityForInfoPortalResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getFacilityForInfoPortal1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/INCUBATOR/stop-places/{id}/facility-info-portal`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FacilityForInfoPortalResponseFromJSON(jsonValue));
    }

    /**
     * Get the facility as for InfoPortal. Temporary solution before it goes to a PlaceService. 
     * Get the facility as for InfoPortal.
     */
    async getFacilityForInfoPortal1(requestParameters: GetFacilityForInfoPortal1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FacilityForInfoPortalResponse> {
        const response = await this.getFacilityForInfoPortal1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of `Place\'s` ordered by their distance to the centre coordinates.
     * Get places nearby given coordinates by longitude/latitude. (Alternately use `v3/places/by-coordinates-geojson` instead.)
     */
    async getPlacesByCoordinatesRaw(requestParameters: GetPlacesByCoordinatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlaceResponse>> {
        if (requestParameters['longitude'] == null) {
            throw new runtime.RequiredError(
                'longitude',
                'Required parameter "longitude" was null or undefined when calling getPlacesByCoordinates().'
            );
        }

        if (requestParameters['latitude'] == null) {
            throw new runtime.RequiredError(
                'latitude',
                'Required parameter "latitude" was null or undefined when calling getPlacesByCoordinates().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['longitude'] != null) {
            queryParameters['longitude'] = requestParameters['longitude'];
        }

        if (requestParameters['latitude'] != null) {
            queryParameters['latitude'] = requestParameters['latitude'];
        }

        if (requestParameters['radius'] != null) {
            queryParameters['radius'] = requestParameters['radius'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['includeVehicleModes'] != null) {
            queryParameters['includeVehicleModes'] = requestParameters['includeVehicleModes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/places/by-coordinates`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of `Place\'s` ordered by their distance to the centre coordinates.
     * Get places nearby given coordinates by longitude/latitude. (Alternately use `v3/places/by-coordinates-geojson` instead.)
     */
    async getPlacesByCoordinates(requestParameters: GetPlacesByCoordinatesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlaceResponse> {
        const response = await this.getPlacesByCoordinatesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns a list of `Place\'s` ordered by their distance to the centre coordinates.
     * Get places nearby given coordinates in GeoJson. (Alternately use `v3/places/by-coordinates` instead.)
     */
    async getPlacesByCoordinatesGeojsonRaw(requestParameters: GetPlacesByCoordinatesGeojsonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlaceResponse>> {
        if (requestParameters['center'] == null) {
            throw new runtime.RequiredError(
                'center',
                'Required parameter "center" was null or undefined when calling getPlacesByCoordinatesGeojson().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['center'] != null) {
            queryParameters['center'] = requestParameters['center'];
        }

        if (requestParameters['radius'] != null) {
            queryParameters['radius'] = requestParameters['radius'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['includeVehicleModes'] != null) {
            queryParameters['includeVehicleModes'] = requestParameters['includeVehicleModes'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/places/by-coordinates-geojson`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceResponseFromJSON(jsonValue));
    }

    /**
     * Returns a list of `Place\'s` ordered by their distance to the centre coordinates.
     * Get places nearby given coordinates in GeoJson. (Alternately use `v3/places/by-coordinates` instead.)
     */
    async getPlacesByCoordinatesGeojson(requestParameters: GetPlacesByCoordinatesGeojsonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlaceResponse> {
        const response = await this.getPlacesByCoordinatesGeojsonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * The response is a flat (non-inherited) structure of concrete places. <br/>The response can be cached during 3 minutes.
     * Get places of type StopPlace, Address,PointOfInterest by its name.
     */
    async getPlacesByNameRaw(requestParameters: GetPlacesByNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PlaceResponse>> {
        if (requestParameters['nameMatch'] == null) {
            throw new runtime.RequiredError(
                'nameMatch',
                'Required parameter "nameMatch" was null or undefined when calling getPlacesByName().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['nameMatch'] != null) {
            queryParameters['nameMatch'] = requestParameters['nameMatch'];
        }

        if (requestParameters['type'] != null) {
            queryParameters['type'] = requestParameters['type'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['center'] != null) {
            queryParameters['center'] = requestParameters['center'];
        }

        if (requestParameters['radius'] != null) {
            queryParameters['radius'] = requestParameters['radius'];
        }

        if (requestParameters['includeVehicleModes'] != null) {
            queryParameters['includeVehicleModes'] = requestParameters['includeVehicleModes'];
        }

        if (requestParameters['includeTouristicVia'] != null) {
            queryParameters['includeTouristicVia'] = requestParameters['includeTouristicVia'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/places`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PlaceResponseFromJSON(jsonValue));
    }

    /**
     * The response is a flat (non-inherited) structure of concrete places. <br/>The response can be cached during 3 minutes.
     * Get places of type StopPlace, Address,PointOfInterest by its name.
     */
    async getPlacesByName(requestParameters: GetPlacesByNameRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PlaceResponse> {
        const response = await this.getPlacesByNameRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the stop place by its id. All Stations will be updated on a weekly base, because of rare changes, please do not use this service too frequently! <br/>The response can be cached during 1 day.
     * Get the `StopPlaceDetailed` (aka stations, bus stops, etc.) known resp. routed by public transportation.
     */
    async getStopPlaceByIdRaw(requestParameters: GetStopPlaceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StopPlaceDetailed>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getStopPlaceById().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['date'] != null) {
            queryParameters['date'] = (requestParameters['date'] as any).toISOString().substring(0,10);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/stop-places/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopPlaceDetailedFromJSON(jsonValue));
    }

    /**
     * Get the stop place by its id. All Stations will be updated on a weekly base, because of rare changes, please do not use this service too frequently! <br/>The response can be cached during 1 day.
     * Get the `StopPlaceDetailed` (aka stations, bus stops, etc.) known resp. routed by public transportation.
     */
    async getStopPlaceById(requestParameters: GetStopPlaceByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StopPlaceDetailed> {
        const response = await this.getStopPlaceByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     *  Provides a download of all transferable `StopPlaceDetailed` known by Atlas (UIC source) resp. INFO+ (planned routes).<br>There are more than 65\'000 such entries.<br>{To compress large responses, set header `accept-encoding` as `gzip`.}<br>All Stations will be updated on a weekly base, because of rare changes, please do not use this service too frequently! <br/>The response can be cached during 1 day.
     * Get the matching `StopPlaceDetailed` (aka stations, bus stops, etc.) known resp. routed by public transportation.
     */
    async getStopPlacesRaw(requestParameters: GetStopPlacesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StopPlaceDetailedResponse>> {
        const queryParameters: any = {};

        if (requestParameters['countryCode'] != null) {
            queryParameters['countryCode'] = requestParameters['countryCode'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['validDate'] != null) {
            queryParameters['validDate'] = (requestParameters['validDate'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['validFrom'] != null) {
            queryParameters['validFrom'] = (requestParameters['validFrom'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['validTo'] != null) {
            queryParameters['validTo'] = (requestParameters['validTo'] as any).toISOString().substring(0,10);
        }

        if (requestParameters['vehicleModes'] != null) {
            queryParameters['vehicleModes'] = requestParameters['vehicleModes'];
        }

        if (requestParameters['nameMatch'] != null) {
            queryParameters['nameMatch'] = requestParameters['nameMatch'];
        }

        if (requestParameters['tariffZone'] != null) {
            queryParameters['tariffZone'] = requestParameters['tariffZone'];
        }

        if (requestParameters['nearby'] != null) {
            queryParameters['nearby'] = requestParameters['nearby'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['requestID'] != null) {
            headerParameters['Request-ID'] = String(requestParameters['requestID']);
        }

        if (requestParameters['acceptLanguage'] != null) {
            headerParameters['Accept-Language'] = String(requestParameters['acceptLanguage']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v3/stop-places`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StopPlaceDetailedResponseFromJSON(jsonValue));
    }

    /**
     *  Provides a download of all transferable `StopPlaceDetailed` known by Atlas (UIC source) resp. INFO+ (planned routes).<br>There are more than 65\'000 such entries.<br>{To compress large responses, set header `accept-encoding` as `gzip`.}<br>All Stations will be updated on a weekly base, because of rare changes, please do not use this service too frequently! <br/>The response can be cached during 1 day.
     * Get the matching `StopPlaceDetailed` (aka stations, bus stops, etc.) known resp. routed by public transportation.
     */
    async getStopPlaces(requestParameters: GetStopPlacesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StopPlaceDetailedResponse> {
        const response = await this.getStopPlacesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetFacilityForInfoPortalAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetFacilityForInfoPortalAcceptLanguageEnum = typeof GetFacilityForInfoPortalAcceptLanguageEnum[keyof typeof GetFacilityForInfoPortalAcceptLanguageEnum];
/**
 * @export
 */
export const GetFacilityForInfoPortal1AcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetFacilityForInfoPortal1AcceptLanguageEnum = typeof GetFacilityForInfoPortal1AcceptLanguageEnum[keyof typeof GetFacilityForInfoPortal1AcceptLanguageEnum];
/**
 * @export
 */
export const GetPlacesByCoordinatesAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetPlacesByCoordinatesAcceptLanguageEnum = typeof GetPlacesByCoordinatesAcceptLanguageEnum[keyof typeof GetPlacesByCoordinatesAcceptLanguageEnum];
/**
 * @export
 */
export const GetPlacesByCoordinatesTypeEnum = {
    All: 'ALL',
    StopPlace: 'StopPlace',
    Address: 'Address',
    PointOfInterest: 'PointOfInterest'
} as const;
export type GetPlacesByCoordinatesTypeEnum = typeof GetPlacesByCoordinatesTypeEnum[keyof typeof GetPlacesByCoordinatesTypeEnum];
/**
 * @export
 */
export const GetPlacesByCoordinatesGeojsonAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetPlacesByCoordinatesGeojsonAcceptLanguageEnum = typeof GetPlacesByCoordinatesGeojsonAcceptLanguageEnum[keyof typeof GetPlacesByCoordinatesGeojsonAcceptLanguageEnum];
/**
 * @export
 */
export const GetPlacesByCoordinatesGeojsonTypeEnum = {
    All: 'ALL',
    StopPlace: 'StopPlace',
    Address: 'Address',
    PointOfInterest: 'PointOfInterest'
} as const;
export type GetPlacesByCoordinatesGeojsonTypeEnum = typeof GetPlacesByCoordinatesGeojsonTypeEnum[keyof typeof GetPlacesByCoordinatesGeojsonTypeEnum];
/**
 * @export
 */
export const GetPlacesByNameAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetPlacesByNameAcceptLanguageEnum = typeof GetPlacesByNameAcceptLanguageEnum[keyof typeof GetPlacesByNameAcceptLanguageEnum];
/**
 * @export
 */
export const GetPlacesByNameTypeEnum = {
    All: 'ALL',
    StopPlace: 'StopPlace',
    Address: 'Address',
    PointOfInterest: 'PointOfInterest'
} as const;
export type GetPlacesByNameTypeEnum = typeof GetPlacesByNameTypeEnum[keyof typeof GetPlacesByNameTypeEnum];
/**
 * @export
 */
export const GetStopPlaceByIdAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetStopPlaceByIdAcceptLanguageEnum = typeof GetStopPlaceByIdAcceptLanguageEnum[keyof typeof GetStopPlaceByIdAcceptLanguageEnum];
/**
 * @export
 */
export const GetStopPlacesAcceptLanguageEnum = {
    De: 'de',
    Fr: 'fr',
    It: 'it',
    En: 'en'
} as const;
export type GetStopPlacesAcceptLanguageEnum = typeof GetStopPlacesAcceptLanguageEnum[keyof typeof GetStopPlacesAcceptLanguageEnum];
/**
 * @export
 */
export const GetStopPlacesSortOrderEnum = {
    Name: 'NAME',
    Weight: 'WEIGHT',
    Distance: 'DISTANCE'
} as const;
export type GetStopPlacesSortOrderEnum = typeof GetStopPlacesSortOrderEnum[keyof typeof GetStopPlacesSortOrderEnum];
